import { render, staticRenderFns } from "./LightingOverview.vue?vue&type=template&id=1b4b189c&scoped=true&"
import script from "./LightingOverview.vue?vue&type=script&lang=js&"
export * from "./LightingOverview.vue?vue&type=script&lang=js&"
import style0 from "./LightingOverview.vue?vue&type=style&index=0&id=1b4b189c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b189c",
  null
  
)

export default component.exports